import { Page } from '@/core/architecture'

import { ConsoleMissionEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMissionEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleMissionEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMissionEditTemplate state={state} {...actions} />
}
